const VERSION_WINDOW_MS = 5 * 60 * 1000;

export function requestInventoryJson() {
  const lang = document.documentElement.lang === 'fr-CA' ? '_fr' : '';
  const url = `/wp-content/uploads/data/inventory${lang}.json?v=${Math.floor(Date.now() / VERSION_WINDOW_MS)}`;
  const requests = window.__lbxInventoryRequests || (window.__lbxInventoryRequests = {});

  if (!requests[url]) {
    requests[url] = fetch(url)
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data) => (data && Array.isArray(data.vehicles) ? data.vehicles : []))
      .catch(() => {
        delete requests[url];
        return [];
      });
  }

  return requests[url];
}

export function onFirstInteraction(callback, target = window, events = ['pointermove', 'pointerdown', 'keydown', 'focusin', 'touchstart', 'scroll']) {
  const run = () => {
    events.forEach((type) => target.removeEventListener(type, run, true));
    callback();
  };

  events.forEach((type) => target.addEventListener(type, run, { capture: true, passive: true }));
}
